storefrontApp.controller("productTutorialVideosQuickViewController", [
    "$q",
    "$scope",
    "$window",
    "elasticService",
    "loaderService",
    "modalService",
    "urlService",
    "$sce",
    function (
        $q,
        $scope,
        $window,
        elasticService,
        loaderService,
        modalService,
        urlService,
        $sanitize
    ) {
        //#region Fields
        $scope.productTutorialVideosQuickView = {
            elasticProductInfo: null,
            searchResults: [],
            currentVideo: null,
        };
        //#endregion

        //#region Events
        $scope.$on(
            "InitializeProductTutorialVideosQuickView",
            function (_event, productvideosresult) {
                $scope.productTutorialVideosQuickView.searchResults[0] =
                productvideosresult;
                    initializeProductTutorialVideosQuickView();
            }
        );
        //#endregion

        //#region  Quick View
        $scope.closeProductTutorialVideosQuickView = function () {
            document.getElementById("yt-player").contentWindow.postMessage('{"event":"command","func":"stopVideo","args":""}', '*');
            modalService.close("productTutorialVideosQuickViewModal");
            resetProductTutorialVideosQuickView();
        };

        $scope.redirectToUrl = function (url) {
            $window.open(url, "_blank");
        };

        //#region Private Functions
        function initializeProductTutorialVideosQuickView() {
            loaderService.show();
            $q.all([
                
                elasticService.getElasticData(
                    elasticService.buildProductInfoRequest(
                        $scope.productTutorialVideosQuickView.searchResults[0].itemId
                            .split("_var_")[0]
                            .toLowerCase()
                    )
                ),
            ]).then(function (responses) {
               loaderService.hide();

                //Search results
               //Elastic product info
               $scope.productTutorialVideosQuickView.elasticProductInfo = _.get(
                responses,
                ["0", "data", "hits", "hits", "0", "_source"]
            );
            
            $scope.productTutorialVideosQuickView.currentVideo =
                    $scope.productTutorialVideosQuickView.searchResults[0];
                
                    _.forEach(
                        $scope.productTutorialVideosQuickView.searchResults,
                        function (item) {
                            item.customPropBrandUrl = urlService.getBrandUrl({
                            catalogId: item.vendorName,
                            productDefinition: (angular.isDefined($scope.productTutorialVideosQuickView
                            .elasticProductInfo)?$scope.productTutorialVideosQuickView
                            .elasticProductInfo.definitionName: 'supplies'),
                            productType:
                            (angular.isDefined($scope.productTutorialVideosQuickView
                                .elasticProductInfo)?$scope.productTutorialVideosQuickView
                                .elasticProductInfo.productType: 'physical'),
                        });
    
                        item.customPropProductImageUrl = urlService.getImageUrl(
                            {
                                catalogId: item.vendorName,
                                definitionName: (angular.isDefined($scope.productTutorialVideosQuickView
                                    .elasticProductInfo)?$scope.productTutorialVideosQuickView
                                    .elasticProductInfo.definitionName: 'supplies'),
                                size: "medium",
                                sku: item.itemId,
                            }
                        );
                        item.customPropProductUrl = urlService.getProductUrl({
                            catalogId: item.vendorName,
                            definitionName: (angular.isDefined($scope.productTutorialVideosQuickView
                                .elasticProductInfo)?$scope.productTutorialVideosQuickView
                                .elasticProductInfo.definitionName: 'supplies'),
                            name:  (angular.isDefined($scope.productTutorialVideosQuickView
                                .elasticProductInfo)?$scope.productTutorialVideosQuickView
                                .elasticProductInfo.definitionName: 'N/A'),
                            sku: item.itemId,
                        });
                        item.videoUrl = $scope.trustAsHtml(item.videoUrl);
                    }
                );
           
                modalService.open("productTutorialVideosQuickViewModal");
           });
        }

        function resetProductTutorialVideosQuickView() {
            $scope.productTutorialVideosQuickView = {
                elasticProductInfo: null,
                searchResults: [],
               
               
            };
        }

        $scope.trustAsHtml = function (html) {
            return $sanitize.trustAsResourceUrl(
                html.toString()
            );
        };
       //#endregion

        //#endregion
    },
]);
